export class Constants {
    // public static readonly k_ROOT_DOMAIN_URL = "https://wshqmobile.thunderprint.org"
    public static readonly k_BASE_WS_URL = "https://wshqmobile.thunderprint.org/HQ_Service.asmx"
    public static readonly k_LOGIN = "TPInsight_MobileLogIn"
    public static readonly k_GET_DEVICE = "TPInsight_GetDevice"
    public static readonly k_DAILY_USAGE = "TPInsight_GetDeviceDailyUsageByDay"
    public static readonly k_MONTHLY_USAGE = "TPInsight_GetDeviceMonthlyUsageByMonth"
    public static readonly k_YEARLY_USAGE = "TPInsight_GetDeviceYearlyUsageByYear"
    public static readonly k_DAILY_IMP = "TPInsight_GetDeviceDailyImpressionsByDay"
    public static readonly k_MONTHLY_IMP = "TPInsight_GetDeviceMonthlyImpressionsByMonth"
    public static readonly k_YEARLY_IMP = "TPInsight_GetDeviceYearlyImpressionsByYear"
    public static readonly k_GET_DEPT = "TPInsight_GetDept"
    // public static readonly k_HOURLY_COMBINED_WIP_OUTPUT = "TPInsight_GetHourlyWIPOutputByDay"
    public static readonly k_HOURLY_WIP = "TPInsight_GetHourlyWIPByDay"
    public static readonly k_HOURLY_OUTPUT = "TPInsight_GetHourlyOutputByDay"
    public static readonly k_HOURLY_OUTPUT_ACCUM = "TPInsight_GetHourlyAccumulatedOutput"
    public static readonly k_GET_PROCESS = "TPInsight_GetProcess"
    // public static readonly k_POST_EMAIL = "TPInsight_PostWipOutputExportEmail"
    public static readonly k_DOWNLOAD_CSV = "TPInsight_DownloadCSV"
    // public static readonly k_GET_MACHINE_DOWN_REASON = "TPInsight_GetMachineDownReason" // OLD WITHOUT PARAM
    public static readonly k_GET_MACHINE_DOWN_PROBLEM = "TPInsight_GetMachineDownProblem" // NEW WITH PARAM
    public static readonly k_GET_MACHINE = "TPInsight_GetMachineByProcess"
    public static readonly k_GET_TRANSFILE = "TPInsight_GetTransfileByMachine"
    public static readonly k_GET_ISSUE_MDOWN = "TPInsight_IssueMachineDown"
    public static readonly k_GET_INSERT_MDOWN_DETAIL = "TPInsight_InsertMachineDownDetail"
    public static readonly k_SEND_SMS = "TPInsight_SendSMSToSupervisor"

    // public static readonly k_BASE_WS_URL       = "https://wscore.thunderprint.org"
    // public static readonly k_LOGIN          = "login"
    // public static readonly k_GET_DEVICE     = "machinelist"
    // public static readonly k_DAILY_USAGE    = "MachineData/utilize/DAILY"
    // public static readonly k_MONTHLY_USAGE  = "MachineData/utilize/MONTHLY"
    // public static readonly k_YEARLY_USAGE   = "MachineData/utilize/YEARLY"
    // public static readonly k_DAILY_IMP      = "MachineData/impression/DAILY"
    // public static readonly k_MONTHLY_IMP    = "MachineData/impression/MONTHLY"
    // public static readonly k_YEARLY_IMP     = "MachineData/impression/YEARLY"
    // public static readonly k_GET_DEPT       = "TPInsight_GetDept"
    // public static readonly k_HOURLY_WIP     = "TPInsight_GetHourlyWIPOutputByDay"

    public static readonly d_WS_STATUS: Dictionary<string> = {
        0: "Success",
        1: "Post Data Not Found",
        2: "Invalid Access Token",
        3: "Error"
    }
    public static readonly c_ACCESS_TOKEN = "accesstoken";
    public static readonly c_MIN_DATE_2019 = "2019-01-01";
    public static readonly c_MIN_DATE_2020 = "2020-03-01";
    public static readonly c_DATE_FORMAT = "YYYY-MM-DD";
    public static readonly c_OP_SEL_DEPT = "OP_SEL_DEPT"; // DEPRECATED
    public static readonly c_OP_SEL_PROC = "OP_SEL_PROC"; // DEPRECATED
    public static readonly c_OP_SEL_MACH = "OP_SEL_MACH"; // DEPRECATED
    public static readonly c_OP_MACHINE_LIST = "OP_MACHINE_LIST"; // DEPRECATED
    public static readonly c_LG_REMEMBER_ME = "LG_REMEMBER_ME";

    public static readonly c_OP_DEPARTMENT = "OP_DEPARTMENT";
    public static readonly c_OP_PROCESS = "OP_PROCESS";
    public static readonly c_OP_MACHINE = "OP_MACHINE";

    public static readonly b_CANCEL = "Cancel"
    public static readonly b_OK = "Ok"

}

export interface Dictionary<T> {
    [K: string]: T;
}

export const enum StatusCode {
    Success,
    PostDataNotFound,
    InvalidAccessToken,
    Error
}

export const enum WSTypeCode {
    WIP = 1,
    Output,
}

export const enum WSAccumCode {
    NonAccum,
    Accum,
}

export const enum WSPackageCode {
    NonPack,
    Pack,
}

declare global {
    interface Window {
        total: any;
    }
}

declare interface String {
    contains(strMatch: string): boolean;
}

export const enum DeploymentTarget {

}

export class LocalStorageCache {
    public selected: ListItem;
    public list: Array<ListItem> = [];
}

export interface ListItem {
    name: string;
    value: string | number;
}